module.exports = __webpack_public_path__ + "img/tmx_future_network.b6440d4a.jpg";